import { render } from "./DetailMooovr.vue?vue&type=template&id=1d579d60&scoped=true"
import script from "./DetailMooovr.vue?vue&type=script&lang=js"
export * from "./DetailMooovr.vue?vue&type=script&lang=js"

import "./DetailMooovr.vue?vue&type=style&index=0&id=1d579d60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d579d60"

export default script